<template>
    <div class="tabs-container">
        <DxTabs :data-source="tabs" v-model:selected-index="selectedIndex" @option-changed="onTabChanged"
            :item-template="tabTemplate" />
        <div v-if="selectedIndex === 0">
            <GridTabParteneri @select-partener="onPartenerSelected" />
        </div>
        <div v-if="selectedIndex === 1">
            <GridParteneriDetalii :partener="selectedPartener" @back="selectedIndex = 0" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { DxTabs } from 'devextreme-vue/tabs';
import CrmParteneri from '@/services/Comercial/CrmParteneri';
import GridTabParteneri from './GridTabParteneri.vue';
import GridParteneriDetalii from './GridParteneriDetalii.vue';
import partenerForm from '@/components/library/partener-form.vue';

export default defineComponent({
    components: {
        DxTabs,
        GridTabParteneri,
        GridParteneriDetalii,
        partenerForm
    },
    data() {
        return {
            tabs: [
                { text: 'Parteneri' },
                { text: 'Detalii' },
            ],
            selectedIndex: 0,
            selectedPartener: null
        };
    },
    mounted() {
        if (this.$route.query.partenerId) {
            const id = this.$route.query.partenerId as string;
            this.fetchPartener(id);
        }
    },
    watch: {
        '$route.query.partenerId': {
            handler(newId) {
                if (newId) {
                    this.fetchPartener(newId as string);
                }
            },
            immediate: true
        }
    },
    methods: {
        onTabChanged(e: any) {
            this.selectedIndex = e.component.option('selectedIndex');
        },
        tabTemplate(itemData: any) {
            return `<div>${itemData.text}</div>`;
        },
        onPartenerSelected(partener: any) {
            this.selectedPartener = partener;
            this.selectedIndex = 1;
        },
        fetchPartener(id: string) {
            if (!id || id === '') return;
            CrmParteneri.getById(id).then((response) => {
                this.selectedPartener = response.data;
                this.selectedIndex = 1;
            }).catch(error => {
                console.error("Error fetching partener:", error);
            });
        }
    }

});
</script>
<style scoped></style>